class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.drawerButtons = [
      document.getElementById("toggle-cart"),
      ...document.querySelectorAll("[data-cart-drawer]"),
    ];
    this.drawerBackdrop = document.querySelector("[data-backdrop]");
  }

  connectedCallback() {
    this.drawerButtons.forEach((button, index) => {
      if(button){
      index === 0
        ? button.addEventListener("click", this.openDrawer.bind(this))
        : button.addEventListener("click", this.closeDrawer.bind(this));  
      }
    });

    this.drawerBackdrop.addEventListener("click", this.closeDrawer.bind(this));
  }

  openDrawer() {
    this.setAttribute("data-active", "");
    isMobile()
      ? freezeBody(true)
      : this.drawerBackdrop.setAttribute("data-active", "");
  }

  closeDrawer() {
    this.removeAttribute("data-active");
    isMobile()
      ? freezeBody(false)
      : this.drawerBackdrop.removeAttribute("data-active");
  }
}

customElements.define("cart-drawer", CartDrawer);
